import * as React from 'react'
import { FC, useCallback } from 'react'
import { WidgetBody } from './WidgetBody'
import { WidgetHeader } from './WidgetHeader'

import Card from '@mui/material/Card'

export interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children?: JSX.Element
  contentBack?: JSX.Element
  contentFront: JSX.Element
  footer?: JSX.Element
  headerColor?: string
  settingsAction: () => void
  showFront: boolean
  title: string
  testIdPrefix?: string
}

export const WidgetWrapper: FC<Props> = (props) => {
  const {
    className,
    contentBack,
    contentFront,
    footer,
    headerColor,
    settingsAction,
    showFront,
    title,
    testIdPrefix = 'widget',
  } = props

  const setFrontSideRotation = () => {
    return showFront ? 'none' : `rotateY(180deg)`
  }

  const handleSettingsAction = useCallback(() => {
    settingsAction()
  }, [settingsAction])

  const cardStyle: Omit<React.CSSProperties, 'appearance'> = {
    transformStyle: 'preserve-3d',
    transition: 'all 0.5s ease',
    transform: setFrontSideRotation(),
  }

  const frontStyle: Omit<React.CSSProperties, 'appearance'> = {
    backfaceVisibility: 'hidden',
  }

  const backStyle: Omit<React.CSSProperties, 'appearance'> = {
    backfaceVisibility: 'hidden',
    transform: `rotateY(180deg)`,
  }

  const frontSide = (
    <Card className={className} elevation={1} style={frontStyle}>
      <WidgetHeader
        action={handleSettingsAction}
        color={headerColor}
        showFront={showFront}
        title={title}
        testIdPrefix={`${testIdPrefix}-header`}
      />
      <WidgetBody>{contentFront}</WidgetBody>
      {footer}
    </Card>
  )

  const backSide = (
    <Card elevation={1} style={backStyle}>
      <WidgetHeader
        action={handleSettingsAction}
        color={headerColor}
        showFront={showFront}
        title={`${title} (Settings)`}
        testIdPrefix={`${testIdPrefix}-header`}
      />
      <WidgetBody>{contentBack}</WidgetBody>
    </Card>
  )

  return <div style={cardStyle}> {showFront ? frontSide : backSide} </div>
}

WidgetWrapper.displayName = 'WidgetWrapper'
